// TODO: once StayCardComponent is deleted, move this to MealPlan
export const MealPlanType = [
  {
    key: 'BB',
    value: 'breakfastIncluded',
    icon: 'breakfast',
    text: 'rdBreakfastIncluded',
    classIcon: 'rhg-font-icon--coffee-tea-facilities'
  },
  {
    key: 'HB',
    value: 'halfBoardIncluded',
    icon: 'halfBoard',
    text: 'rdHalfBoardRate',
    classIcon: 'rhg-font-icon--half-board'
  },
  {
    key: 'FB',
    value: 'fullBoard',
    icon: 'fullBoard',
    text: 'rdFullBoard',
    classIcon: 'rhg-font-icon--fullboard'
  },
  {
    key: 'RO',
    value: 'roomOnly',
    icon: 'roomOnly',
    text: 'rdRoomOnly',
    classIcon: 'icon-room-only'
  },
  {
    key: 'AI',
    value: 'allInclusive',
    icon: 'allInclusive',
    text: 'rdAllInclusive',
    classIcon: 'rhg-font-icon--all-inclusive'
  },
  {
    key: 'HBL',
    value: 'halfBoard',
    icon: 'halfBoard',
    text: 'rdBreakfastAndLunchIncluded',
    classIcon: 'rhg-font-icon--half-board'
  }
]
